/* Warenkorb-Schublade (TECHNIK 22.10.2026). Shopify Ajax API: /cart.js, /cart/change.js, /cart/update.js.
   Öffnet auf cart:open (product-form.js) und auf Klick auf den Warenkorb der Kopfleiste. Bleibt passiv, solange das PickyStory-Script auf der Seite liegt. */
(function () {
  'use strict';
  var root = document.getElementById('cart-drawer');
  if (!root) return;
  var picky = !!document.querySelector('script[src*="pickystory"]');
  var panel = document.getElementById('cart-drawer-panel');
  var overlay = document.getElementById('cart-drawer-overlay');
  var closeBtn = document.getElementById('cart-drawer-close');
  var liste = document.getElementById('cart-drawer-items');
  var zahl = document.getElementById('cart-drawer-count');
  var summe = document.getElementById('cart-drawer-total');
  var kasse = document.getElementById('bgc-kasse');
  var versand = document.getElementById('bgc-versand');
  var balken = document.getElementById('shipping-progress');
  var vText = document.getElementById('shipping-message');
  var vBetrag = document.getElementById('shipping-amount');
  var doBox = document.getElementById('bgc-do');
  var schwelle = parseInt(root.dataset.threshold, 10) || 5000;
  var letzterFokus = null;
  var offen = false;
  var cart = null;

  function geld(cents) {
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function bild(url) { if (!url) return ''; return url.indexOf('?') > -1 ? url + '&width=160' : url + '?width=160'; }

  function render(c) {
    cart = c;
    zahl.textContent = c.item_count;
    summe.textContent = geld(c.total_price);
    if (kasse) kasse.disabled = c.item_count === 0;
    var rest = schwelle - c.total_price;
    var anteil = Math.max(0, Math.min(100, (c.total_price / schwelle) * 100));
    balken.style.width = anteil + '%';
    if (rest <= 0) { versand.classList.add('is-frei'); vText.textContent = 'Gratis Versand'; vBetrag.textContent = geld(schwelle); }
    else { versand.classList.remove('is-frei'); vText.textContent = 'Noch ' + geld(rest) + ' bis Gratis Versand'; vBetrag.textContent = 'ab ' + geld(schwelle); }
    if (doBox) doBox.hidden = !c.items.some(function (it) { return it.product_type === 'Blut Test' || it.product_type === 'DNA Test' || /mikrobiom/i.test(it.product_title || ''); });
    if (!c.items.length) {
      liste.innerHTML = '<div class="bgc-leer"><p>Dein Warenkorb ist leer.</p><a class="bgc-knopf bgc-knopf-zweit" href="/collections/all">Alle Tests ansehen</a></div>';
      return;
    }
    liste.innerHTML = c.items.map(function (it) {
      var variante = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="bgc-variante">' + esc(it.variant_title) + '</p>' : '';
      var img = it.image ? '<img src="' + esc(bild(it.image)) + '" width="80" height="80" alt="' + esc(it.product_title) + '">' : '';
      return '<div class="bgc-artikel" data-key="' + esc(it.key) + '">' +
        '<a class="bgc-bild" href="' + esc(it.url) + '">' + img + '</a>' +
        '<div class="bgc-artikel-text"><a class="bgc-artikel-titel" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variante +
        '<div class="bgc-menge" role="group" aria-label="Menge"><button type="button" class="bgc-menge-knopf" data-step="-1" aria-label="Eins weniger">−</button><span class="bgc-menge-zahl">' + it.quantity + '</span><button type="button" class="bgc-menge-knopf" data-step="1" aria-label="Eins mehr">+</button></div></div>' +
        '<div class="bgc-artikel-rechts"><button type="button" class="bgc-entfernen" aria-label="' + esc(it.product_title) + ' entfernen"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button><span class="bgc-preis">' + geld(it.final_line_price) + '</span></div></div>';
    }).join('');
  }

  function laden() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); return c; })
      .catch(function () {});
  }

  function aendern(key, menge) {
    root.classList.add('is-busy');
    return fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: menge }) })
      .then(function (r) { return r.json(); })
      .then(function (c) { if (c && c.items) render(c); else return laden(); })
      .catch(function () { return laden(); })
      .then(function () { root.classList.remove('is-busy'); document.dispatchEvent(new CustomEvent('cart:updated', { detail: { quelle: 'drawer' } })); });
  }

  function oeffnen() {
    if (offen) { laden(); return; }
    letzterFokus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bgc-offen');
    requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.add('is-open'); }); });
    offen = true;
    laden();
    setTimeout(function () { closeBtn.focus({ preventScroll: true }); }, 60);
  }
  function schliessen() {
    if (!offen) return;
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bgc-offen');
    offen = false;
    setTimeout(function () { if (!offen) root.hidden = true; }, 360);
    if (letzterFokus && letzterFokus.focus) letzterFokus.focus({ preventScroll: true });
  }

  /* Gutscheincode: zuerst der neue Weg über /cart/update.js (discount), sonst der klassische Weg über /discount/CODE (gilt dann an der Kasse) */
  function codeAnwenden(form) {
    var eingabe = form.querySelector('input');
    var hinweis = form.querySelector('.bgc-feld-hinweis');
    var code = (eingabe.value || '').trim();
    hinweis.classList.remove('is-fehler');
    if (!code) { hinweis.textContent = 'Bitte einen Code eingeben.'; hinweis.classList.add('is-fehler'); return; }
    hinweis.textContent = 'Wird geprüft …';
    fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var codes = c && c.discount_codes;
        if (Array.isArray(codes)) {
          var treffer = codes.filter(function (d) { return (d.code || '').toLowerCase() === code.toLowerCase(); })[0];
          if (treffer && treffer.applicable) { render(c); hinweis.textContent = 'Code angewendet. Der Rabatt steht an der Kasse.'; return; }
          if (treffer && treffer.applicable === false) { hinweis.textContent = 'Dieser Code gilt für diesen Warenkorb nicht.'; hinweis.classList.add('is-fehler'); return; }
        }
        return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).then(function () {
          hinweis.textContent = 'Code gespeichert. Er wird an der Kasse angewendet.';
        });
      })
      .catch(function () { hinweis.textContent = 'Code konnte nicht geprüft werden.'; hinweis.classList.add('is-fehler'); });
  }
  function notizSpeichern(form) {
    var eingabe = form.querySelector('textarea');
    var hinweis = form.querySelector('.bgc-feld-hinweis');
    fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ note: eingabe.value }) })
      .then(function (r) { return r.json(); })
      .then(function () { hinweis.classList.remove('is-fehler'); hinweis.textContent = 'Kommentar gespeichert.'; })
      .catch(function () { hinweis.classList.add('is-fehler'); hinweis.textContent = 'Kommentar konnte nicht gespeichert werden.'; });
  }
  function teilen() {
    var hinweis = document.getElementById('bgc-teilen-hinweis');
    if (!cart || !cart.items.length) { hinweis.textContent = 'Der Warenkorb ist leer.'; setTimeout(function () { hinweis.textContent = ''; }, 2500); return; }
    var link = location.origin + '/cart/' + cart.items.map(function (it) { return it.variant_id + ':' + it.quantity; }).join(',');
    var fertig = function () { hinweis.textContent = 'Link kopiert!'; setTimeout(function () { hinweis.textContent = ''; }, 2500); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(link).then(fertig, function () { prompt('Link zum Warenkorb', link); });
    else prompt('Link zum Warenkorb', link);
  }

  /* Ereignisse */
  liste.addEventListener('click', function (e) {
    var artikel = e.target.closest('.bgc-artikel'); if (!artikel) return;
    var key = artikel.dataset.key;
    var menge = parseInt(artikel.querySelector('.bgc-menge-zahl').textContent, 10) || 0;
    if (e.target.closest('.bgc-entfernen')) { e.preventDefault(); aendern(key, 0); return; }
    var knopf = e.target.closest('.bgc-menge-knopf');
    if (knopf) { e.preventDefault(); aendern(key, Math.max(0, menge + parseInt(knopf.dataset.step, 10))); }
  });
  root.querySelectorAll('.bgc-extra').forEach(function (b) {
    b.addEventListener('click', function () {
      var ziel = document.getElementById(b.dataset.ziel); var auf = ziel.hidden;
      ziel.hidden = !auf; b.setAttribute('aria-expanded', auf ? 'true' : 'false');
      if (auf) { var f = ziel.querySelector('input,textarea'); if (f) f.focus({ preventScroll: true }); }
    });
  });
  document.getElementById('bgc-code').addEventListener('submit', function (e) { e.preventDefault(); codeAnwenden(this); });
  document.getElementById('bgc-notiz').addEventListener('submit', function (e) { e.preventDefault(); notizSpeichern(this); });
  document.getElementById('bgc-teilen').addEventListener('click', teilen);
  closeBtn.addEventListener('click', schliessen);
  overlay.addEventListener('click', schliessen);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && offen) schliessen(); });
  document.addEventListener('cart:close', schliessen);
  document.addEventListener('cart:updated', function (e) { if (!(e.detail && e.detail.quelle === 'drawer')) laden(); });

  if (picky) return; /* PickyStory öffnet seine eigene Schublade, unsere bleibt zu */
  document.addEventListener('cart:open', oeffnen);
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a.bgh-cart, a[href="/cart"], a[href$="/cart"]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault(); oeffnen();
  });
  /* Kaufknöpfe der Seiten sind einfache Formulare an /cart/add (z. B. bsk-form). Früher hat PickyStory sie abgefangen,
     jetzt legt die Schublade das Produkt per Ajax in den Warenkorb und öffnet sich. Formulare in product-form regelt product-form.js selbst. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || e.defaultPrevented || form.closest('product-form')) return;
    var ziel = (form.getAttribute('action') || '').split('?')[0];
    if (!/\/cart\/add\/?$/.test(ziel)) return;
    e.preventDefault();
    var knopf = e.submitter || form.querySelector('[type="submit"]');
    if (knopf) knopf.setAttribute('aria-busy', 'true');
    var daten = new FormData(form);
    if (knopf && knopf.name && !daten.has(knopf.name)) daten.append(knopf.name, knopf.value);
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: daten })
      .then(function (r) { if (!r.ok) throw r.status; return r.json(); })
      .then(function () { return laden(); })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:updated', { detail: { quelle: 'drawer' } })); oeffnen(); })
      .catch(function () { form.submit(); })
      .then(function () { if (knopf) knopf.removeAttribute('aria-busy'); });
  });
  window.cartDrawer = { open: oeffnen, close: schliessen, refresh: laden };
})();
